import { makeStyles } from 'tss-react/mui'

const layoutPaddingTop = '10px'
const headerWrapperHeight = '67px'
const backButtonRowHeight = '45px'

export const useStyles = makeStyles<{
  fullHeight: boolean
  scrollBar?: boolean
}>()((theme, { fullHeight, scrollBar = true }) => ({
  root: {
    backgroundColor: theme.palette.opaque.light,
  },
  stickyExternalHeaders: {
    position: 'relative',
    height: headerWrapperHeight,
    zIndex: 999,
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    backgroundColor: theme.palette.opaque.light,
    height: fullHeight
      ? '100vh'
      : `calc(100vh - ${layoutPaddingTop} - ${headerWrapperHeight})`,
    overflow: scrollBar ? 'auto' : 'hidden',
  },
  withBackButton: {
    height: `calc(100vh - ${layoutPaddingTop} - ${headerWrapperHeight} - ${backButtonRowHeight})`,
  },
  appBody: {
    width: '100%',
  },
  backButtonContainer: {
    boxSizing: 'border-box',
    height: backButtonRowHeight,
    textAlign: 'left',
    display: 'flex',
    fontWeight: 600,
    alignItems: 'center',
    paddingLeft: theme.spacing(3.75),
    paddingBottom: theme.spacing(0.625),
  },
}))
